<script>
  import CardTab from '@/components/Card/Tab';
  import ArrowLeft from '@/assets/arrow-left.svg';
  import ArrowRight from '@/assets/arrow-right.svg';
  import OrderTable from '@/components/Transaction/Order/Table';

  export default {
    components: {
      CardTab,
      ArrowLeft,
      ArrowRight,
      OrderTable,
    },

    data: () => ({
      tab: 1,
    }),

    computed: {
      items () {
        return [
          'Book de ofertas', 'Minhas ordens',
        ];
      },
    },
  };
</script>

<template>
  <article class="transaction-order card">
    <CardTab
      v-model="tab"
      :items="items"
      />

    <div class="card__body" v-if="tab === 0">
      <div class="transaction-order__content">
        <OrderTable class="transaction-order__table" />

        <section class="transaction-order__pressure">
          <div
            class="transaction-order__pressure-item transaction-order__pressure-item--positive"
            >
            R$930.0000,00
          </div>
          <div
            class="transaction-order__pressure-item transaction-order__pressure-item--negative"
            >
            R$850.0000,00
          </div>
        </section>

        <OrderTable class="transaction-order__table" negative />
      </div>

      <nav class="transaction-order__pagination">
        <ul class="transaction-order__pagination-items">
          <li class="transaction-order__pagination-item">
            <a
              href="#"
              class="transaction-order__pagination-link"
              >
              <ArrowLeft />
            </a>
          </li>

          <li class="transaction-order__pagination-item" :key="index" v-for="index in 5">
            <a
              href="#"
              v-text="index"
              class="transaction-order__pagination-link"
              :class="{ 'transaction-order__pagination-link--active': index == 2 }"
              >
            </a>
          </li>

          <li class="transaction-order__pagination-item">
            <a
              href="#"
              class="transaction-order__pagination-link"
              >
              <ArrowRight />
            </a>
          </li>
        </ul>
      </nav>
    </div>

    <div class="card__body" v-if="tab === 1">
      <div class="transaction-order__content transaction-order__my-order transaction-table">
        <table>
          <thead>
            <tr>
              <th>Ordem</th>
              <th>Data</th>
              <th>Tipo</th>
              <th>Quantidade</th>
              <th>Executada</th>
              <th>Preço</th>
              <th>Ação</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <span class="transaction-my-order__type">C</span>
              </td>
              <td>02/05/19</td>
              <td>Limitada</td>
              <td>300</td>
              <td>182</td>
              <td>R$ 20.000,00</td>
              <td>
                <button
                  class="transaction-my-order__cancel"
                  >
                  Cancelar
                </button>
              </td>
            </tr>
            <tr>
              <td>
                <span class="transaction-my-order__type">C</span>
              </td>
              <td>02/05/19</td>
              <td>Limitada</td>
              <td>300</td>
              <td>182</td>
              <td>R$ 20.000,00</td>
              <td>
                <button
                  class="transaction-my-order__cancel"
                  >
                  Cancelar
                </button>
              </td>
            </tr>
            <tr>
              <td>
                <span class="transaction-my-order__type transaction-my-order__type--sell">V</span>
              </td>
              <td>02/05/19</td>
              <td>Limitada</td>
              <td>300</td>
              <td>182</td>
              <td>R$ 20.000,00</td>
              <td>
                <button
                  class="transaction-my-order__cancel"
                  >
                  Cancelar
                </button>
              </td>
            </tr>
            <tr>
              <td>
                <span class="transaction-my-order__type">C</span>
              </td>
              <td>02/05/19</td>
              <td>Limitada</td>
              <td>300</td>
              <td>182</td>
              <td>R$ 20.000,00</td>
              <td>
                <button
                  class="transaction-my-order__cancel"
                  >
                  Cancelar
                </button>
              </td>
            </tr>
            <tr>
              <td>
                <span class="transaction-my-order__type transaction-my-order__type--sell">V</span>
              </td>
              <td>02/05/19</td>
              <td>Limitada</td>
              <td>300</td>
              <td>182</td>
              <td>R$ 20.000,00</td>
              <td>
                Executada
              </td>
            </tr>
            <tr>
              <td>
                <span class="transaction-my-order__type transaction-my-order__type--sell">V</span>
              </td>
              <td>02/05/19</td>
              <td>Limitada</td>
              <td>300</td>
              <td>182</td>
              <td>R$ 20.000,00</td>
              <td>
                Executada
              </td>
            </tr>
            <tr>
              <td>
                <span class="transaction-my-order__type transaction-my-order__type--sell">V</span>
              </td>
              <td>02/05/19</td>
              <td>Limitada</td>
              <td>300</td>
              <td>182</td>
              <td>R$ 20.000,00</td>
              <td>
                <button
                  class="transaction-my-order__cancel"
                  >
                  Cancelar
                </button>
              </td>
            </tr>
            <tr>
              <td>
                <span class="transaction-my-order__type">C</span>
              </td>
              <td>02/05/19</td>
              <td>Limitada</td>
              <td>300</td>
              <td>182</td>
              <td>R$ 20.000,00</td>
              <td>
                Executada
              </td>
            </tr>
            <tr>
              <td>
                <span class="transaction-my-order__type">C</span>
              </td>
              <td>02/05/19</td>
              <td>Limitada</td>
              <td>300</td>
              <td>182</td>
              <td>R$ 20.000,00</td>
              <td>
                Executada
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </article>
</template>

<style lang="scss">
  .transaction-order {
    .card-tab {
      &__item--active .card-tab__item-link {
        color: #FFF;
      }

      &__border {
        background-color: #FFF;
      }
    }

    &__content {
      display: flex;
      justify-content: space-between;
    }

    &__table {
      width: 264px;
    }

    &__my-order {
      tr th {
        border: 0 !important;
        width: auto !important;

        &:last-of-type {
          width: 3% !important;
        }
      }
    }

    &__pressure {
      width: 137px;
      color: #FFF;
      height: 170px;
      font-size: 14px;
      font-weight: 500;
      align-self: center;

      &-item {
        padding: 8px;
        display: flex;
        border-radius: 4px;
        align-items: flex-end;
        justify-content: center;

        &--positive {
          z-index: 1;
          height: 62%;
          position: relative;
          margin-bottom: -4px;
          background-color: #509e02;
        }

        &--negative {
          height: 38%;
          background-color: #d0021b;
        }
      }
    }

    &__pagination {
      margin-top: 24px;

      &-items {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &-link {
        height: 17px;
        display: flex;
        margin: 0 2px;
        padding: 0 5px;
        color: #b2b8c5;
        font-size: 12px;
        font-weight: 500;
        border-radius: 2px;
        align-items: center;
        letter-spacing: 0.24px;

        &:hover {
          background-color: rgba(#FFF, .1);
        }

        &--active {
          color: #FFF;
          background-color: #3e388b !important;
        }
      }
    }
  }
</style>
